import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { HashLink } from "react-router-hash-link";
const CenterMode = () => {
  return (
    <>
      <div id="carouselExample" className="carousel slide  pt-0">
        <Carousel
          interval={3000}
          autoPlay={true}
          showIndicators={false}
          showThumbs={false}
        >
          <div className="carousel-inner pt-3 ">
            {/* Carousel Item 1 */}
            <div className="carousel-item active">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "700px" }}
              >
                <div className="card" style={{ width: "22rem" }}>
                  <img
                    src="images/assets/imaging.png" // Replace with your actual image path
                    className="card-img-top"
                    alt="Slide 1"
                    style={{ objectFit: "cover", height: "250px" }}
                  />
                  <div className="card-body text-primary-emphasis">
                    <h5 className="card-title">IMAGING</h5>
                    <p className="card-text text-start">
                      Our imaging team provides a variety of exams and
                      procedures in a comfortable outpatient environment. We
                      apply state of the art technology to provide accurate
                      diagnostic results. If you would like to know more about
                      your upcoming exam or procedure. Rapid Lab offers fast and
                      precise turnaround times for all radiological reports. Our
                      radiologists and sonographers will make reports and films
                      (images) ready in an hour after examinations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Carousel Item 2 */}
            <div className="carousel-item ">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "700px" }}
              >
                <div className="card" style={{ width: "22rem" }}>
                  <img
                    src="images/assets/ultraSound.jpeg" // Replace with your actual image path
                    className="card-img-top"
                    alt="Slide 1"
                    style={{ objectFit: "cover", height: "250px" }}
                  />
                  <div className="card-body text-primary-emphasis">
                    <h5 className="card-title">ULTRASOUND</h5>
                    <p className="card-text text-start">
                      Ultrasound is a non-invasive, radiation-free imaging
                      method that uses high-frequency sound waves to produce
                      real-time images of the body. A handheld device called a
                      transducer, along with a special gel, is placed on the
                      skin. The transducer sends sound waves into the body,
                      which bounce back and are captured to form images. This
                      technique allows for safe, live visualization of internal
                      organs, their motion, and blood flow without exposing
                      patients to ionizing radiation.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Carousel Item 3 */}
            <div className="carousel-item ">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "700px" }}
              >
                <div className="card" style={{ width: "22rem" }}>
                  <img
                    src="images/assets/doppler-ultrasound.png" // Replace with your actual image path
                    className="card-img-top"
                    alt="Slide 1"
                    style={{ objectFit: "cover", height: "250px" }}
                  />
                  <div className="card-body text-primary-emphasis">
                    <h5 className="card-title lh-1">
                      {" "}
                      DOPPLER VASCULAR ULTRASOUND
                    </h5>
                    <p className="card-text text-start">
                      Doppler vascular ultrasound is a specialized imaging
                      method that enables doctors to assess blood flow in
                      arteries and veins throughout the body, including the
                      abdomen, limbs, neck, brain, liver, and kidneys. It
                      creates detailed images and accurate measurements of blood
                      vessels, helping detect abnormalities or diseases. This
                      technique aids radiologists in identifying various
                      vascular conditions promptly, ensuring effective diagnosis
                      and treatment planning for patients of all ages. <br />
                      <HashLink
                        className="link-primary link-offset"
                        to="/#F&Q"
                        smooth
                      >
                        Learn More{" "}
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="60"
                            height="30"
                            fill="blue"
                            className="bi bi-arrow-right"
                            viewBox="0 0 19 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                            />
                          </svg>
                        </span>
                      </HashLink>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Carousel Item 4 */}
            <div className="carousel-item ">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "700px" }}
              >
                <div className="card" style={{ width: "22rem" }}>
                  <img
                    src="images/assets/x-ray.png" // Replace with your actual image path
                    className="card-img-top"
                    alt="Slide 1"
                    style={{ objectFit: "cover", height: "250px" }}
                  />
                  <div className="card-body text-primary-emphasis">
                    <h5 className="card-title ">X-RAY ANALYSIS</h5>
                    <p className="card-text text-start">
                      X-rays, or radiographs, are the oldest and most common
                      imaging method, used to detect fractures, infections, or
                      foreign objects.
                      <span className="fw-bold">
                        {" "}
                        Rapid Laboratory and Diagnostics Center{" "}
                      </span>{" "}
                      offers affordable X-rays—up to 60% less than hospital
                      rates—with same-day, next-day, and walk-in options. With
                      extended hours and accessible locations, our caring
                      technologists and expert radiologists ensure a smooth
                      experience and provide accurate results to support your
                      doctor’s diagnosis and treatment decisions. <br />{" "}
                      <HashLink
                        className="link-primary link-offset"
                        to="/#x-ray"
                        smooth
                      >
                        Learn More{" "}
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="60"
                            height="30"
                            fill="blue"
                            className="bi bi-arrow-right"
                            viewBox="0 0 19 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                            />
                          </svg>
                        </span>
                      </HashLink>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Carousel>

        <button
          className="carousel-control-prev "
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon"></span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon"></span>
        </button>
      </div>
    </>
  );
};

export default CenterMode;
